<div appFocusOut (elementFocusOut) = "onFocusout()">
  <span class="profile" (click)="show = !show">
    {{userDetails.displayName}} <i class="fa user" aria-hidden="true"></i>
  </span>
  <div class="profile-container" *ngIf="show">
    <div class="tile" (click)="viewUserDetails()">
      <span class="fa user-black"></span>
      <span class="title">View Profile</span>
    </div>
    <div class="tile">
      <span class="fa chat-question"></span>
      <span class="title">
        <a href="mailto:selina.broun@bhp.com">Help & Support </a>
      </span>
    </div>
    <div class="tile" (click)="logout()">
      <span class="fa logout"></span>
      <span class="title">Log Out</span>
    </div>
  </div>
</div>
